/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Aria_LabelInputs */

const en_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align text right`)
};

const fr_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner le texte a droite`)
};

const de_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text rechtsbündig ausrichten`)
};

const it_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allinea il testo a destra`)
};

const ru_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выравнивание текста по правому краю`)
};

const es_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinear el texto a la derecha`)
};

const zh_cn2_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本右对齐`)
};

const ja_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを右揃えにする`)
};

const hi_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को दाईं ओर संरेखित करें`)
};

const pt_pt2_align_right_aria_label = /** @type {(inputs: Align_Right_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhar texto à direita`)
};

/**
* | output |
* | --- |
* | "Align text right" |
*
* @param {Align_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_aria_label = /** @type {((inputs?: Align_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_right_aria_label(inputs)
	if (locale === "de") return de_align_right_aria_label(inputs)
	if (locale === "it") return it_align_right_aria_label(inputs)
	if (locale === "ru") return ru_align_right_aria_label(inputs)
	if (locale === "es") return es_align_right_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_align_right_aria_label(inputs)
	if (locale === "ja") return ja_align_right_aria_label(inputs)
	if (locale === "hi") return hi_align_right_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_align_right_aria_label(inputs)
	return en_align_right_aria_label(inputs)
});